<template>
  <div>
    <h2 class="content-heading">
      <button type="button" class="btn btn-sm btn-success btn-noborder float-right" @click="openManualRefundModal">
        <i class="fa fa-plus mr-5"></i>Nieuwe Retour
      </button>
      <i class="si si-basket mr-5"></i> Retours
    </h2>
    <manual-refund-modal v-if="ManualDetailModalShow"  @close="ManualDetailModalShow = false" ></manual-refund-modal>
    <api-table-block ref="ordersTable" :fields="fields" :items="findAllRefunds" default-sort-by="created_at" item-label-singular="bestelling" item-label-plural="bestellingen">
      <template slot="before-block-content">
        <div class="block-content">
          <div class="pull-right">
            <label class="css-control css-control-sm css-control-primary css-switch ">
              <input type="checkbox" class="css-control-input" v-model="showOnlyProcessing" @change="refresh">
              <span class="css-control-indicator"></span> Alleen openstaand
            </label>

            <label class="css-control css-control-sm css-control-primary css-switch">
              <input type="checkbox" class="css-control-input" v-model="showOnlyDropship" @change="refresh">
              <span class="css-control-indicator"></span> Alleen dropshipments
            </label>
          </div>
        </div>
      </template>

          <template slot="check" slot-scope="data">
        <label class="css-control css-control-primary css-checkbox" :key="data.item.order.number">
          <input type="checkbox" class="css-control-input" :checked="selectedOrders.includes(data.item.order.number)" @change="selectOrder(data.item.order.number, $event)">
          <span class="css-control-indicator"></span>
        </label>
      </template>
      <template slot="number" slot-scope="data">
        <a href="#" @click.prevent="openDetailModal(data.item.order.id, data.item.id)">#{{data.item.order_number}}</a>
      </template>
      <template slot="billing_person" slot-scope="data">
        {{data.item.order.billing_person}} <small v-if="data.item.order.billing_company" class="text-muted">{{data.item.order.billing_company}}</small>
      </template>
      <template slot="placed_at" slot-scope="data">
        {{data.item.order.placed_at | moment('calendar') | capitalize}}
      </template>
      <template slot="status" slot-scope="data">
        <refund-status-badge :refund="data.item" />
      </template>
      <template slot="actions" slot-scope="data">
        <button class="btn btn-sm btn-secondary" @click="openDetailModal(data.item.order.id, data.item.id)">Details</button>
      </template>
      </api-table-block>

      <barcode-scanner @scan="openDetailModal" />
    <refund-detail-modal v-if="detailModalOrderId" :key="detailModalOrderId" :order-id="detailModalOrderId" :refundId="detailModalRefundId"  :includeRefundShipmentCosts="true" @close="detailModalOrderId = null, refresh()" ></refund-detail-modal>
    
  </div>
</template>

<script>
import ApiTableBlock from '../common/ApiTableBlock'
import RefundDetailModal from './RefundDetailModal'
import RefundStatusBadge from './RefundStatusBadge.vue'
import BarcodeScanner from '../common/BarcodeScanner'
import ManualRefundModal from './ManualRefundModal.vue'

export default {
  components: {
    ApiTableBlock,
    RefundDetailModal,
    BarcodeScanner,
    RefundStatusBadge,
    ManualRefundModal
  },
  data () {
    return {
      fields: {
        check: {
          label: '',
          class: 'text-center',
          thStyle: 'width: 70px;'
        },
        number: {
          label: 'Bestelling',
          sortable: true,
          thStyle: 'width: 140px;'
        },
        billing_person: {
          label: 'Klant',
          sortable: true,
          thStyle: 'width: 30%;'
        },
        placed_at: {
          label: 'Datum',
          sortable: true
        },
        status: {
          label: 'Status',
          sortable: true
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 150px;'
        }
      },
      selectedOrders: [],
      detailModalOrderId: null,
      detailModalRefundId: null,
      ManualDetailModalShow: false,
      showOnlyProcessing: true,
      showOnlyDropship: false
    }
  },
  computed: {
    ordersTable () {
      return this.$refs.ordersTable
    }
  },
  methods: {
    findAllRefunds (params) {
      params['include'] = 'order'

      if (this.showOnlyProcessing) {
        params['filter[status]'] = 'in-process'
      } else {
        params['filter[status]'] = 'in-process,completed'
      }

      return this.$api.getRefunds(params)
    },
    refresh () {
      this.ordersTable.refresh()
    },
    openDetailModal (orderId, refundId) {
      this.detailModalOrderId = orderId
      this.detailModalRefundId = refundId
    },
    openManualRefundModal () {
      this.ManualDetailModalShow = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// RefundsPage.vue?91ce75ce